import React, { createContext, useContext, useEffect } from "react";

import "../styles/wellperformance.css";

import "../styles/resizable.css";
import "../styles/grid-layout.css";
import { Layout, notification, Radio, Tooltip } from "antd";
import { CommandBar, ProgressIndicator } from "@fluentui/react";

import { SubPageHeaderTitle } from "../../../../shared/SubPageHeaderTitle";

import { Select } from "antd";
import FieldProductionTrendStore from "../store/FieldProductionTrendStore";
import { Observer, observer } from "mobx-react-lite";

import { Responsive, WidthProvider } from "react-grid-layout";

import MainStore from "../../../home/store/mainStore";
import { ProductionTrendChart } from "./ProductionTrendChart";
import { CummulativeTrendChart } from "./CummulativeTrendChart";
import { APIChart } from "./APIChart";

const { Content } = Layout;
const ResponsiveGridLayout = WidthProvider(Responsive);

const fieldProductionTrendStoreCtx = createContext(FieldProductionTrendStore);

const { Option } = Select;

const mainStoreCtx = createContext(MainStore);
export const FieldprodTrendBaseView = observer(() => {
  const fieldProductionTrendStore = useContext(fieldProductionTrendStoreCtx);
  const mainStore = useContext(mainStoreCtx);

  useEffect(() => {
    async function loadUniqueFieldData() {
      try {
        await fieldProductionTrendStore.getuniqueFieldsData();
        const fId = fieldProductionTrendStore.selectedField.fieldId;
        await fieldProductionTrendStore.getFieldPlotData(fId);
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: `download failed,${error.message}`,
        });
      }
    }
    loadUniqueFieldData();
    mainStore.resetAssetContext();
  }, []);

  return (
    <Layout
      style={{
        background: "#fff",
        padding: "10px",
        borderTop: "2px solid #ff6f00",
      }}
    >
      <Content>
        {" "}
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <CommandBar
                items={[
                  {
                    key: "1",
                    onRender: () => (
                      <div style={{ paddingTop: "5px" }}>
                        <Observer>
                          {() => (
                            <SubPageHeaderTitle
                              title={`${fieldProductionTrendStore.selectedField.fieldName} Field Production Trend`}
                            />
                          )}
                        </Observer>
                      </div>
                    ),
                  },
                ]}
                farItems={[
                  {
                    key: "5",
                    onRender: () => (
                      <div className="ms-Grid" dir="ltr">
                        <div className="ms-Grid-row">
                          <div className="ms-Grid-col ms-sm7">
                            <Tooltip title="Toogle field selection to load all the fields or only the currently producing fields">
                              <Radio.Group
                                defaultValue={true}
                                buttonStyle="solid"
                                size="small"
                                onChange={async (e) => {
                                  fieldProductionTrendStore.isproducing =
                                    e.target.value;
                                  await fieldProductionTrendStore.getuniqueFieldsData();
                                }}
                              >
                                <Radio.Button value={true}>
                                  Producing Fields
                                </Radio.Button>
                                <Radio.Button value={false}>
                                  All Fields
                                </Radio.Button>
                              </Radio.Group>
                            </Tooltip>
                          </div>
                          <div className="ms-Grid-col ms-sm5">
                            {
                              <Observer>
                                {() => (
                                  <Select
                                    showSearch
                                    style={{ width: 150 }}
                                    placeholder="Select a Field"
                                    value={
                                      fieldProductionTrendStore.selectedField
                                        .fieldName
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      option.children.indexOf(
                                        input.toLowerCase()
                                      ) >= 0
                                    }
                                    onChange={async (value, obj) => {
                                      console.log(value, obj);
                                      fieldProductionTrendStore.selectedField =
                                        {
                                          fieldId: obj.value,
                                          fieldName: obj.children,
                                        };
                                      await fieldProductionTrendStore.getFieldPlotData(
                                        value
                                      );
                                    }}
                                  >
                                    {fieldProductionTrendStore.uniqueFields.map(
                                      (field) => (
                                        <Option
                                          value={field.fieldId}
                                          key={field.fieldId}
                                        >
                                          {field.fieldName}
                                        </Option>
                                      )
                                    )}
                                  </Select>
                                )}
                              </Observer>
                            }
                          </div>
                        </div>
                      </div>
                    ),
                  },
                ]}
              ></CommandBar>
            </div>
          </div>

          {fieldProductionTrendStore.isLoadiFields && (
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm8"></div>
              <div className="ms-Grid-col ms-sm4">
                {" "}
                <ProgressIndicator
                  description={`loading,${
                    fieldProductionTrendStore.isproducing
                      ? "Producing Fields"
                      : "All Fields"
                  } `}
                />
              </div>
            </div>
          )}
          <div
            className="ms-Grid-row"
            style={{
              marginTop: "5px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          ></div>

          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <ResponsiveGridLayout
                className="layout"
                draggableCancel=".chart-container-control, .chart-container-controls, .highcharts-container, .highcharts-contextmenu, .highcharts-menu"
                breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                rowHeight={100}
              >
                <div
                  key="1"
                  data-grid={{ x: 0, y: 0, w: 12, h: 4 }}
                  className=" ms-motion-fadeIn"
                >
                  <ProductionTrendChart />
                </div>
                <div
                  key="4"
                  data-grid={{ x: 0, y: 1, w: 12, h: 4 }}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <CummulativeTrendChart />
                </div>
                <div
                  key="5"
                  data-grid={{ x: 0, y: 2, w: 12, h: 4 }}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <APIChart />
                </div>
              </ResponsiveGridLayout>
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
});

